const toType = obj => {
  let type_str = Object.prototype.toString.call(obj);
  return type_str.slice(8, -1);
};

const isNumber = type => {
  return toType(type) == "Number";
};
const isObject = type => {
  return toType(type) == "Object";
};
const isString = type => {
  return toType(type) == "String";
};
const isBoolean = type => {
  return toType(type) == "Boolean";
};
const isSymbol = type => {
  return toType(type) == "Symbol";
};
const isUndefined = type => {
  return toType(type) == "Undefined";
};
const isNull = type => {
  return toType(type) == "Null";
};
const isNullorUndefined = type => {
  return toType(type) == "Null" || toType(type) == "Undefined";
};
const isFunction = type => {
  return toType(type) == "Function";
};
const isDate = type => {
  return toType(type) == "Date";
};
const isArray = type => {
  return toType(type) == "Array";
};
const isRegExp = type => {
  return toType(type) == "RegExp";
};
const isError = type => {
  return toType(type) == "Error";
};
const isHTMLDocument = type => {
  return toType(type) == "HTMLDocument";
};
const iswindow = type => {
  return toType(type) == "window";
};
const isPromise = type => {
  return toType(type) == "Promise";
};
const isAsyncFunction = type => {
  return toType(type) == "AsyncFunction";
};
const isHaveProp = (obj, prop) => {
  return obj.hasOwnProperty(prop);
};
const isEmpty = obj => {
  if (
    (isObject(obj) && Object.keys(obj).length == 0) ||
    toType(obj) == "Null" ||
    toType(obj) == "Undefined" ||
    (isArray(obj) && obj.length == 0) ||
    (isBoolean(obj) && !obj)
  ) {
    return true;
  }
  return false;
};
const isEmptyObject = obj => {
  return Object.keys(obj).length == 0;
};
export default {
  toType,
  isNumber,
  isObject,
  isString,
  isBoolean,
  isSymbol,
  isUndefined,
  isNull,
  isNullorUndefined,
  isFunction,
  isDate,
  isArray,
  isRegExp,
  isError,
  isHTMLDocument,
  iswindow,
  isPromise,
  isAsyncFunction,
  isHaveProp,
  isEmpty,
  isEmptyObject
};
